export const stripePublishableKeyLive =
  'pk_live_51JI99CFpeomcrrjBIMbMTBuln5aqiSw2GcZo4FFIzc1k9qp6FOlMM7Maea3qar6FdKmzgkE1bkNbvJAMpWMGhBfa00FM5Orkxg'
// export const stripePublishableKeyTest = 'pk_test_51JI99CFpeomcrrjBex8vhzWjH7TmOVou6rDNWMOmzrNEc44ByETSOiPIwEn1rDmP7jUR3tCaA9yvSqP2QjvTbGHI00KKRRUuN2'
